import payementInitialize from './paymentScheduleUpdate'; // eslint-disable-line import/no-cycle

/**
 * Toggles payment methods buttons based on the state of the Step 5 checkout input fields
 * @param {Array} $paymentMethods - List of payment methods
 */
const toggleDropinButtons = ($paymentMethods) => {
    const $form = $('.js-payment-method-form');
    const validator = $form.validate();
    const isSkipSEPA = $('.js-skip-sepa').val() === 'true';
    const selectors = ['#termsAndConditionsCheck'];

    if (!isSkipSEPA) {
        selectors.push('#dwfrm_paymentDetails_accountHolder', '#dwfrm_paymentDetails_accountNumber', '#dwfrm_paymentDetails_agreeAutomaticSEPA');
    }

    const isValid = selectors.every((selector) => {
        const $field = $(selector);
        return $field.length > 0 && validator.check($field[0]);
    });

    $paymentMethods.forEach(($paymentMethod) => {
        const isCreditCard = $paymentMethod.hasClass('adyen-checkout__payment-method--credit')
            || $paymentMethod.hasClass('adyen-checkout__payment-method--bcmc');
        const classToAdd = isCreditCard ? 'payment-method-credit-card-disabled' : 'payment-method-disabled';

        if (isValid) {
            $paymentMethod.removeClass(classToAdd);
        } else {
            $paymentMethod.addClass(classToAdd);
        }
    });
};

/**
 * Updates membership duration plan HTML wrapper with the given HTML string
 * @param {string} membershipDurationPlanHTML - HTML string
 */
const updateMembershipDuration = (membershipDurationPlanHTML) => {
    if (!membershipDurationPlanHTML || typeof membershipDurationPlanHTML !== 'string') {
        return;
    }

    const memberShipDurationPlan = $('.js-membershipDurationPlan');
    const activeMemberShipDuration = memberShipDurationPlan.find('.js-first-part-checkboxes');
    activeMemberShipDuration.replaceWith(membershipDurationPlanHTML);
    payementInitialize();
};

/**
 * Updates payment schedule options on checkout step 5
 * @param {Object} data - Payload data
 */
const updatePaymentScheduleOptions = ({
    isFlex,
    isPromotionAvailable,
    is13PeriodDiscount,
    isLowEntryBarrierPromotion,
    isFoundingMember,
    subscriptionPrice,
    discountedMonthlyPrice,
    originalTotalPrice,
    totalPrice,
    promotionFlexLabel,
    promotionLabel4Weeks,
    promotionLabel52Weeks,
    promotion13Label4Weeks,
    promotion13Label52Weeks,
    defaultDescription4Weeks,
    lowEntryBarrierDescription4Weeks,
    isStrikeThroughPrice,
}) => {
    const $4WeeksPaymentScheduleOption = $('.js-payment-schedule.fourWeeks');
    const $52WeeksPaymentScheduleOption = $('.js-payment-schedule.52weeks');
    const $4WeeksDescription = $4WeeksPaymentScheduleOption.find('.js-promotion-description');
    const $4WeeksPrice = $4WeeksPaymentScheduleOption.find('.card__price');
    const $52WeeksPrice = $52WeeksPaymentScheduleOption.find('.card__price');

    $4WeeksDescription.html(isLowEntryBarrierPromotion ? lowEntryBarrierDescription4Weeks : defaultDescription4Weeks);

    if (isPromotionAvailable || isFoundingMember) {
        const $4WeeksDiscountedPrice = $4WeeksPaymentScheduleOption.find('.discounted-price');
        const $52WeeksDiscountedPrice = $52WeeksPaymentScheduleOption.find('.discounted-price');
        const $4WeeksStrikeThroughPrice = $4WeeksPaymentScheduleOption.find('.strike-through-price');
        const $52WeeksStrikeThroughPrice = $52WeeksPaymentScheduleOption.find('.strike-through-price');
        const $4WeeksPromotionLabel = $4WeeksPaymentScheduleOption.find('.sub-text');
        const $52WeeksPromotionLabel = $52WeeksPaymentScheduleOption.find('.sub-text');
        let label4Weeks;

        if (isFlex) {
            label4Weeks = promotionFlexLabel;
        } else if (is13PeriodDiscount) {
            label4Weeks = promotion13Label4Weeks;
        } else {
            label4Weeks = promotionLabel4Weeks;
        }

        if (discountedMonthlyPrice) {
            if ($4WeeksDiscountedPrice.length > 0) {
                $4WeeksDiscountedPrice.html(discountedMonthlyPrice);
            } else {
                $4WeeksPrice.html(discountedMonthlyPrice);
            }
        }
        if (totalPrice) {
            if ($52WeeksDiscountedPrice.length > 0) {
                $52WeeksDiscountedPrice.html(totalPrice);
            } else {
                $52WeeksPrice.html(totalPrice);
            }
        }
        if (isStrikeThroughPrice && subscriptionPrice) {
            $4WeeksStrikeThroughPrice.html(subscriptionPrice);
        }
        if (isStrikeThroughPrice && originalTotalPrice) {
            $52WeeksStrikeThroughPrice.html(originalTotalPrice);
        }
        if (label4Weeks) {
            $4WeeksPromotionLabel.html(label4Weeks);
        }
        if (promotion13Label52Weeks || promotionLabel52Weeks) {
            $52WeeksPromotionLabel.html(is13PeriodDiscount ? promotion13Label52Weeks : promotionLabel52Weeks);
        }
    } else {
        if (subscriptionPrice) {
            $4WeeksPrice.html(subscriptionPrice);
        }
        if (originalTotalPrice) {
            $52WeeksPrice.html(originalTotalPrice);
        }
    }
};

/**
 * Toggles one cent promotion content on checkout step 5
 * @param {string} paymentInterval - Payment interval (fourWeeks, 52weeks)
 * @param {boolean} isOneCentPromotion - True if one cent promotion is available, False otherwise
 */
const toggleOneCentPromotionContent = (paymentInterval, isOneCentPromotion) => {
    const is4Weeks = paymentInterval === 'fourWeeks';
    const $4Weeks = $('.js-per-4-weeks-asset');
    const $52Weeks = $('.js-per-52-weeks-asset');
    const $oneCentPromotionAsset = $('.js-one-cent-promotion-asset');
    const $oneCentPromotionDisclaimer = $('.js-one-cent-promotion-disclaimer');
    const $oneCentPromotionMobileDisclaimer = $('.js-mobile-summary-block');

    if (isOneCentPromotion) {
        $4Weeks.hide();
        $52Weeks.hide();
        $oneCentPromotionAsset.show();
    } else if (is4Weeks) {
        $4Weeks.show();
        $52Weeks.hide();
        $oneCentPromotionAsset.hide();
    } else {
        $4Weeks.hide();
        $52Weeks.show();
        $oneCentPromotionAsset.hide();
    }

    if (isOneCentPromotion && is4Weeks) {
        $oneCentPromotionDisclaimer.removeClass('display-none');
        $oneCentPromotionMobileDisclaimer.show();
    } else {
        $oneCentPromotionDisclaimer.addClass('display-none');
        $oneCentPromotionMobileDisclaimer.hide();
    }
};

export {
    toggleDropinButtons,
    updateMembershipDuration,
    updatePaymentScheduleOptions,
    toggleOneCentPromotionContent,
};
